module.exports = __webpack_public_path__ + "img/punch-card.2d7472ef.svg";